/* Edit Suits redesign 2026: small progressive enhancements for the esr- sections.
   Every section renders complete without this file; it only adds image swapping,
   review paging, showroom tabs and the mobile booking bar. */
(function () {
  if (window.__esrInit) return;
  window.__esrInit = true;

  function swapImg(img, src) {
    if (!img || !src || img.getAttribute('src') === src) return;
    img.style.opacity = 0;
    setTimeout(function () {
      img.removeAttribute('srcset');
      img.src = src;
      img.style.opacity = 1;
    }, 180);
  }

  function init(root) {
    // collection list: hover/focus swaps the image
    root.querySelectorAll('[data-esr-switcher]').forEach(function (sec) {
      var img = sec.querySelector('.esr-swap img');
      var links = sec.querySelectorAll('.esr-cats a');
      links.forEach(function (a) {
        function show() {
          links.forEach(function (x) { x.classList.toggle('is-on', x === a); });
          swapImg(img, a.dataset.esrImg);
        }
        a.addEventListener('mouseenter', show);
        a.addEventListener('focus', show);
      });
    });

    // reviews: previous / next
    root.querySelectorAll('[data-esr-reviews]').forEach(function (sec) {
      var items = sec.querySelectorAll('.esr-review');
      var count = sec.querySelector('[data-esr-count]');
      var i = 0;
      function render() {
        items.forEach(function (el, n) { el.hidden = n !== i; });
        if (count) count.textContent = (i + 1) + ' / ' + items.length;
      }
      var prev = sec.querySelector('[data-esr-prev]');
      var next = sec.querySelector('[data-esr-next]');
      if (prev) prev.addEventListener('click', function () { i = (i + items.length - 1) % items.length; render(); });
      if (next) next.addEventListener('click', function () { i = (i + 1) % items.length; render(); });
    });

    // showrooms: country tabs + photo per showroom
    root.querySelectorAll('[data-esr-showrooms]').forEach(function (sec) {
      var img = sec.querySelector('.esr-swap img');
      var care = sec.querySelector('[data-esr-care]');
      var book = sec.querySelector('[data-esr-book]');
      // phones: each showroom gets its own photo next to its address (the big photo above is out of view)
      var phone = window.matchMedia('(max-width: 989px)');
      function addThumbs() {
        if (!phone.matches) return;
        sec.querySelectorAll('.esr-store[data-esr-img]').forEach(function (s) {
          if (s.querySelector('.esr-store__thumb') || !s.dataset.esrImg) return;
          var t = document.createElement('img');
          t.className = 'esr-store__thumb';
          t.alt = '';
          t.decoding = 'async';
          t.src = s.dataset.esrImg.replace(/([?&])width=\d+/, '$1width=480').replace(/_\d+x(\.\w+)/, '_480x$1');
          s.appendChild(t);
        });
      }
      addThumbs();
      if (phone.addEventListener) phone.addEventListener('change', addThumbs);
      function showStore(store) {
        if (!store) return;
        sec.querySelectorAll('.esr-store').forEach(function (x) { x.classList.toggle('is-on', x === store); });
        swapImg(img, store.dataset.esrImg);
      }
      sec.querySelectorAll('.esr-store').forEach(function (s) {
        s.addEventListener('mouseenter', function () { showStore(s); });
        s.addEventListener('focus', function () { showStore(s); });
      });
      sec.querySelectorAll('.esr-tabs button').forEach(function (b) {
        b.addEventListener('click', function () {
          var c = b.dataset.esrCountry;
          sec.querySelectorAll('.esr-tabs button').forEach(function (x) { x.setAttribute('aria-selected', x === b); });
          sec.querySelectorAll('.esr-stores').forEach(function (l) { l.hidden = l.dataset.esrCountry !== c; });
          if (care) care.textContent = care.dataset[c] || '';
          if (book) book.setAttribute('href', book.dataset[c] || book.dataset.default);
          showStore(sec.querySelector('.esr-stores[data-esr-country="' + c + '"] .esr-store'));
        });
      });
      showStore(sec.querySelector('.esr-stores:not([hidden]) .esr-store'));
    });

    // mobile booking bar: hide while the booking tool is on screen
    root.querySelectorAll('[data-esr-mobile-cta]').forEach(function (bar) {
      var target = bar.dataset.esrHideOver && document.querySelector(bar.dataset.esrHideOver);
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('is-away', e.isIntersecting); });
      }, { threshold: 0.15 }).observe(target);
    });
  }

  // booking tool: mockup title + 5-step progress bar, and the showroom photo follows the chosen
  // location. Read-only towards booking.js: it only watches which #stepN is visible and reuses the
  // tool's own showroom tabs; no booking markup, ids or handlers are changed.
  function initBooking() {
    var panel = document.querySelector('.booking_section_overlay .booking-grid__item:first-child');
    if (!panel || panel.querySelector('.esr-bk-head')) return;
    var de = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
    var title = de ? 'Termin buchen' : 'Book your appointment';
    var labels = de ? ['Angaben', 'Termin', 'Datum', 'Uhrzeit', 'Bestätigen'] : ['Details', 'Service', 'Date', 'Time', 'Confirm'];
    var head = document.createElement('div');
    head.className = 'esr-bk-head';
    head.innerHTML = '<p class="esr-bk-title" role="heading" aria-level="2">' + title + '</p><ol class="esr-bk-progress" aria-label="Booking progress">' +
      labels.map(function (l) { return '<li>' + l + '</li>'; }).join('') + '</ol>';
    var anchor = panel.querySelector('#aligner');
    if (anchor) anchor.after(head); else panel.prepend(head);
    var prog = head.querySelector('.esr-bk-progress');
    var items = prog.querySelectorAll('li');

    // Perfect Fit Guarantee badge under every step until the appointment is confirmed
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var ring = de ? 'EDIT SUITS CO. · PASSFORMGARANTIE · ' : 'EDIT SUITS CO. · PERFECT FIT GUARANTEE · ';
    var badge = document.createElement('div');
    badge.className = 'esr-bk-guarantee';
    badge.innerHTML =
      '<svg class="esr-bk-guarantee__icon" viewBox="0 0 100 100" aria-hidden="true">' +
        '<defs><path id="esrGuarRing" d="M50,50 m-37,0 a37,37 0 1,1 74,0 a37,37 0 1,1 -74,0"/></defs>' +
        '<circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" stroke-width="1.5"/>' +
        '<circle cx="50" cy="50" r="28" fill="none" stroke="currentColor" stroke-width="1"/>' +
        '<text font-size="9" letter-spacing="1.6" fill="currentColor"><textPath href="#esrGuarRing" textLength="228">' + ring + '</textPath></text>' +
        '<path d="M37 51 L46 60 L64 40" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<p>' + (de
        ? '<a href="' + root + 'pages/fit-guarantee" target="_blank" rel="noopener">Erfahren Sie mehr</a> über unsere <b>Passformgarantie</b>'
        : '<a href="' + root + 'pages/fit-guarantee" target="_blank" rel="noopener">Learn more</a> about our <b>Perfect Fit Guarantee</b>') + '</p>';
    var lastStep = panel.querySelector('#step16') || panel.querySelectorAll('.booking-page__steps')[panel.querySelectorAll('.booking-page__steps').length - 1];
    if (lastStep && lastStep.parentNode) lastStep.parentNode.appendChild(badge); else panel.appendChild(badge);
    function current() {
      for (var n = 1; n <= 16; n++) {
        var el = document.getElementById('step' + n);
        if (el && el.offsetParent !== null && getComputedStyle(el).display !== 'none') return n;
      }
      return 1;
    }
    function update() {
      var n = current();
      prog.hidden = n > 6;
      badge.hidden = n > 5;
      items.forEach(function (li, i) {
        li.classList.toggle('is-done', n >= 6 || i < n - 1);
        li.classList.toggle('is-now', n <= 5 && i === n - 1);
      });
    }
    var queued = false;
    new MutationObserver(function () {
      if (queued) return; queued = true;
      requestAnimationFrame(function () { queued = false; update(); });
    }).observe(panel, { subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    update();

    if (window.jQuery) {
      window.jQuery('#salesLocation').on('change', function () {
        var v = (this.value || '').toLowerCase();
        if (!v) return;
        var tabs = document.querySelectorAll('.showroom-carousel__tabs .tab');
        for (var i = 0; i < tabs.length; i++) {
          if ((tabs[i].getAttribute('data-source') || '').indexOf(v.split(' ')[0]) === 0) {
            var a = tabs[i].querySelector('a'); if (a) a.click();
            break;
          }
        }
      });
    }

    groupSlots(de);
    calendarScroll();
  }

  // Step 4: split the time slots into Morning / Afternoon like the mockup. booking.js rewrites
  // .time-slots with one <ul>; the <li> elements are only moved (text untouched), and booking.js
  // reads them through a delegated '.time-slots li' click and '.time-slots .active', so it keeps working.
  function groupSlots(de) {
    var box = document.querySelector('.booking_section_overlay .time-slots');
    if (!box) return;
    var names = de ? ['Vormittag', 'Nachmittag'] : ['Morning', 'Afternoon'];
    function regroup() {
      var lists = box.querySelectorAll(':scope > ul');
      if (lists.length !== 1 || box.querySelector('.esr-slot-group')) return;
      var lis = Array.prototype.slice.call(lists[0].children);
      var am = [], pm = [];
      lis.forEach(function (li) { (parseInt(li.textContent, 10) < 12 ? am : pm).push(li); });
      if (!am.length || !pm.length) {
        var only = document.createElement('p'); only.className = 'esr-slot-group'; only.textContent = am.length ? names[0] : names[1];
        box.insertBefore(only, lists[0]);
        return;
      }
      var frag = document.createDocumentFragment();
      [[names[0], am], [names[1], pm]].forEach(function (g) {
        var p = document.createElement('p'); p.className = 'esr-slot-group'; p.textContent = g[0];
        var ul = document.createElement('ul');
        g[1].forEach(function (li) { ul.appendChild(li); });
        frag.appendChild(p); frag.appendChild(ul);
      });
      box.replaceChildren(frag);
    }
    new MutationObserver(regroup).observe(box, { childList: true });
    regroup();
  }

  // Step 3: show the next months stacked under the current one and scroll down through them instead
  // of paging with arrows. booking.js colours only the month it requested (get_days), so after each of
  // its get_days calls the other visible months are fetched with the same query (read-only GET) and
  // coloured the same way, honouring the same 6 / 8-week booking window.
  function calendarScroll() {
    var $ = window.jQuery;
    if (!$ || !document.getElementById('datepicker')) return;
    var tries = 0;
    (function waitForPicker() {
      var $dp = $('#datepicker');
      if (!$.fn.datepicker || !$dp.hasClass('hasDatepicker')) { if (tries++ < 200) setTimeout(waitForPicker, 150); return; }
      // booking.js reads the shown month/year from $('.ui-datepicker-month').text() / ('.ui-datepicker-year');
      // with 3 months drawn that concatenates ("OctoberNovemberDecember", "202620262026") and sends the calendar
      // to a nonsense date. Keep those classes on the first month only, right after every redraw (an observer,
      // since the page loads jQuery UI twice and $.datepicker gets swapped).
      function soloTitle() {
        $dp.find('.ui-datepicker-group').slice(1).find('.ui-datepicker-month, .ui-datepicker-year').each(function () {
          this.className = this.className.replace(/\bui-datepicker-(month|year)\b/, 'esr-dp-$1');
        });
      }
      new MutationObserver(soloTitle).observe($dp[0], { childList: true, subtree: true });
      $dp.datepicker('option', 'numberOfMonths', [3, 1]);
      soloTitle();
    })();

    var lastUrl = null, cache = {};
    var COLOURS = { '#e27d09': '#EBA739', '#22964b': '#7BD998' };
    function monthUrl(url, y, m) {
      return url.replace(/([?&])year=\d+/, '$1year=' + y).replace(/([?&])month=\d+/, '$1month=' + m);
    }
    function windowDays() {
      var days = 42;
      try {
        var sid = $('input[name="service_id"]').val();
        if (typeof resolveAppointmentType === 'function' && window.serviceData && window.serviceData[sid] &&
            resolveAppointmentType(window.serviceData[sid][0].title) === 'browsing') days = 56;
      } catch (e) {}
      return days;
    }
    function limitOn() {
      try { return typeof onlyShowFourWeeks === 'undefined' ? true : !!onlyShowFourWeeks; } catch (e) { return true; }
    }
    function paint(data, y, m) {
      if (!data || !data.open_days_with_colors) return;
      var limit = new Date(); limit.setDate(limit.getDate() + windowDays());
      var useLimit = limitOn();
      Object.keys(data.open_days_with_colors).forEach(function (full) {
        if (useLimit && new Date(full) > limit) return;
        var parts = full.split('-');
        if (+parts[0] !== y || +parts[1] !== m) return;
        var bg = data.open_days_with_colors[full];
        bg = COLOURS[bg] || bg;
        $('#datepicker td[data-year="' + y + '"][data-month="' + (m - 1) + '"]').not('.ui-datepicker-other-month').each(function () {
          var a = $(this).find('a');
          if (a.attr('data-date') == +parts[2]) { a.css('background-color', bg); $(this).addClass('clickable'); }
        });
      });
    }
    function paintOthers() {
      if (!lastUrl) return;
      var primary = (lastUrl.match(/[?&]year=(\d+)/) || [])[1] + '-' + (lastUrl.match(/[?&]month=(\d+)/) || [])[1];
      var seen = {};
      $('#datepicker td[data-month]').not('.ui-datepicker-other-month').each(function () {
        var y = +this.getAttribute('data-year'), m = +this.getAttribute('data-month') + 1, key = y + '-' + m;
        if (key === primary || seen[key]) return;
        seen[key] = true;
        var url = monthUrl(lastUrl, y, m);
        if (cache[url]) { paint(cache[url], y, m); queueTrim(); return; }
        $.ajax({ url: url, dataType: 'json', esrExtra: true, global: false }).done(function (data) { cache[url] = data; paint(data, y, m); queueTrim(); });
      });
    }
    // only the calendar's own request counts (booking.js also checks each advisor's availability
    // with get_days; those carry a user_id without user_email and must not drive the colours)
    function isCalendarRequest(url) {
      if (!/get_days\.json/.test(url) || !/[?&]user_email=/.test(url)) return false;
      var uid = (url.match(/[?&]user_id=(\d+)/) || [])[1];
      var sel = +$('#salesPerson').val() || 0;
      return uid ? +uid === sel : sel === 0;
    }
    $(document).ajaxComplete(function (e, xhr, s) {
      if (s && !s.esrExtra && isCalendarRequest(s.url || '')) { lastUrl = s.url; setTimeout(paintOthers, 0); }
    });
    window.__esrBookingCal = function () { return { lastUrl: lastUrl, cached: Object.keys(cache) }; };

    // only let the calendar scroll as far as there are open slots: hide the months after the last open day,
    // and the weeks after it within its month (green / orange = open; grey or unpainted = none)
    function isOpen(a) {
      var bg = (a.style.backgroundColor || '').replace(/\s/g, '').toLowerCase();
      return /rgb\(123,217,152\)|rgb\(235,167,57\)|#7bd998|#eba739/.test(bg);
    }
    function trimCalendar() {
      var groups = Array.prototype.slice.call(document.querySelectorAll('#datepicker .ui-datepicker-group'));
      if (groups.length < 2) return;
      var last = -1, lastRow = null;
      groups.forEach(function (g, gi) {
        g.querySelectorAll('td:not(.ui-datepicker-other-month) a').forEach(function (a) {
          if (isOpen(a)) { last = gi; lastRow = a.closest('tr'); }
        });
      });
      groups.forEach(function (g, gi) {
        g.hidden = last >= 0 && gi > last;
        var after = false;
        g.querySelectorAll('tbody tr').forEach(function (tr) {
          tr.hidden = gi === last && after;
          if (tr === lastRow) after = true;
        });
      });
    }
    var trimQueued = false;
    function queueTrim() { if (trimQueued) return; trimQueued = true; setTimeout(function () { trimQueued = false; trimCalendar(); }, 60); }
    $(document).ajaxComplete(function (e, xhr, s) { if (/get_days\.json/.test((s && s.url) || '')) queueTrim(); });
    var dpTrim = document.getElementById('datepicker');
    if (dpTrim) new MutationObserver(queueTrim).observe(dpTrim, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    // the picker redraws its table on refresh/setDate; put the extra months' colours back
    var dp = document.getElementById('datepicker'), pending = false;
    if (dp) new MutationObserver(function () {
      if (pending) return; pending = true;
      setTimeout(function () { pending = false; paintOthers(); }, 0);
    }).observe(dp, { childList: true });
  }

  // Low-resolution photos (e.g. the Singapore showroom, 697px wide) still fill their frame, but always load the
  // largest file available so the browser never picks a smaller srcset candidate and upscales it further.
  function guardLowRes() {
    var sel = '[data-esr-showrooms] .esr-media img, .booking_section_overlay .showroom-carousel img';
    function check(img) {
      if (!img.naturalWidth) return;
      var box = img.getBoundingClientRect();
      var need = Math.max(box.width, box.height * img.naturalWidth / img.naturalHeight);
      var fig = img.closest('figure, .showroom-item, .showroom_inner') || img.parentElement;
      var small = img.naturalWidth * (window.devicePixelRatio > 1 ? 1.25 : 1) < need * 0.9;
      if (small && img.getAttribute('sizes') !== '100vw' && img.srcset) img.setAttribute('sizes', '100vw'); // load the largest file there is
    }
    function bind(img) {
      if (img.dataset.esrLowres) return; img.dataset.esrLowres = '1';
      img.addEventListener('load', function () { check(img); });
      if (img.complete) check(img);
    }
    document.querySelectorAll(sel).forEach(bind);
    new MutationObserver(function () { document.querySelectorAll(sel).forEach(function (img) { bind(img); check(img); }); })
      .observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset'] });
    window.addEventListener('resize', function () { document.querySelectorAll(sel).forEach(check); });
  }

  // product info panel: sticky, but if it is taller than the window it first scrolls with the page until its last
  // button is visible, then sticks (top = window height - panel height).
  // Desktop only. On phones the two columns stack, so there is nothing for the panel to stick beside - the
  // negative offset just lifted it out of place and left a blank band before the Style details accordion.
  function productPanel() {
    var panel = document.querySelector('.esr-tpl-product .product__info-wrapper');
    if (!panel) return;
    var twoCol = window.matchMedia('(min-width: 750px)');
    function place() {
      if (!twoCol.matches) { panel.style.removeProperty('top'); return; }
      var top = Math.min(0, window.innerHeight - panel.offsetHeight - 24);
      panel.style.setProperty('top', top + 'px', 'important');
    }
    place();
    window.addEventListener('resize', place);
    window.addEventListener('load', place);
    if (twoCol.addEventListener) twoCol.addEventListener('change', place);
    if (window.ResizeObserver) new ResizeObserver(place).observe(panel);
  }

  // booking phone field: keep the typed number / placeholder clear of the flag + dial code at any width
  // (the theme's CSS overrides the padding intl-tel-input measures, so set it from the real width)
  function phonePad() {
    var input = document.querySelector('.booking_section_overlay input#phone');
    if (!input || !window.ResizeObserver) return;
    function fit() {
      var flag = input.parentElement && input.parentElement.querySelector('.iti__flag-container');
      if (flag && flag.offsetWidth) input.style.setProperty('padding-left', (flag.offsetWidth + 14) + 'px', 'important');
    }
    var tries = 0;
    (function wait() {
      var flag = input.parentElement && input.parentElement.querySelector('.iti__flag-container');
      if (!flag) { if (tries++ < 100) setTimeout(wait, 150); return; }
      fit();
      new ResizeObserver(fit).observe(flag);
    })();
  }

  // mobile homepage header: transparent over the hero until the page scrolls
  function scrolledFlag() {
    var hdr = document.querySelector('.section-header');
    function measure() { if (hdr) document.documentElement.style.setProperty('--esr-header-h', hdr.offsetHeight + 'px'); }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    var on = false;
    function check() { var v = window.scrollY > 8; if (v !== on) { on = v; document.body.classList.toggle('esr-scrolled', v); } }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  // booking tool: advisor photos the booking server can't serve as images (.webp sent as text/plain + nosniff)
  // are swapped for copies hosted in the theme (map set in theme.liquid)
  function advisorPhotos() {
    var map = window.esrAdvisorPhotos;
    if (!map) return;
    function fix(root) {
      (root.querySelectorAll ? root : document).querySelectorAll('img[src*=".webp"]').forEach(function (img) {
        var src = img.getAttribute('src') || '';
        for (var k in map) { if (src.indexOf(k) !== -1 && src !== map[k]) { img.setAttribute('src', map[k]); break; } }
      });
      document.querySelectorAll('[data-img-url*=".webp"]').forEach(function (o) {
        for (var k in map) { if (o.dataset.imgUrl.indexOf(k) !== -1) { o.dataset.imgUrl = map[k]; break; } }
      });
    }
    fix(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length || muts[i].type === 'attributes') { fix(document); break; } }
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'data-img-url'] });
  }

  // mobile menu: show the tap, close the drawer, then go to the page (or scroll to the section on this page)
  function mobileMenuNav() {
    var drawer = document.querySelector('#menu-drawer');
    if (!drawer) return;
    drawer.addEventListener('click', function (e) {
      var a = e.target.closest('.esr-mnav a, .esr-mnav__secondary a, .esr-mnav__cta');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || a.target === '_blank') return;
      var url;
      try { url = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
      e.preventDefault();
      a.classList.add('is-pressed');
      var hd = document.querySelector('header-drawer');
      var summary = hd && hd.querySelector('summary');
      var samePage = url.origin === location.origin && url.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '') && url.hash;
      setTimeout(function () {
        // close the drawer: the same end state the theme's close animation sets (done directly, so it can't stall)
        var d = hd && hd.querySelector('details');
        if (d) { d.classList.remove('menu-opening'); d.removeAttribute('open'); }
        if (summary) summary.setAttribute('aria-expanded', 'false');
        var hdr = document.querySelector('.header'); if (hdr) hdr.classList.remove('menu-open');
        document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
        a.classList.remove('is-pressed');
        if (samePage) {
          var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
          setTimeout(function () {
            if (target) {
              var hdr = document.querySelector('.section-header');
              var off = hdr ? hdr.offsetHeight : 0;
              window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - off, behavior: 'smooth' });
              history.replaceState(null, '', url.hash);
            }
          }, 260);
        } else {
          location.href = url.href;
        }
      }, 140);
    });
  }


  // Collection header: keep the first paragraph visible and fold the rest behind
  // the same "See more" toggle used by the SEO blocks (.esr-seo__more).
  function cheadSeeMore(root) {
    var scope = root || document;
    var intros = scope.querySelectorAll('.esr-chead__intro');
    Array.prototype.forEach.call(intros, function (intro) {
      if (intro.querySelector('.esr-seo__more')) return;          // already folded
      var rte = intro.querySelector(':scope > .esr-rte');
      if (!rte) return;
      var kids = Array.prototype.filter.call(rte.children, function (n) {
        return n.textContent && n.textContent.trim();
      });
      if (kids.length < 2) return;                                 // nothing worth hiding
      var i18n = window.esrI18n || {};
      var det = document.createElement('details');
      det.className = 'esr-seo__more';
      var sum = document.createElement('summary');
      var span = document.createElement('span');
      span.className = 'esr-link';
      span.setAttribute('data-more', i18n.readMore || 'See more');
      span.setAttribute('data-less', i18n.readLess || 'See less');
      sum.appendChild(span);
      det.appendChild(sum);
      var holder = document.createElement('div');
      holder.className = 'esr-rte';
      kids.slice(1).forEach(function (n) { holder.appendChild(n); });
      det.appendChild(holder);
      rte.parentNode.insertBefore(det, rte.nextSibling);
    });
  }

  function boot() { init(document); initBooking(); guardLowRes(); productPanel(); phonePad(); scrolledFlag(); cheadSeeMore(document); advisorPhotos(); mobileMenuNav(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // theme editor: re-run when a section is re-rendered
  document.addEventListener('shopify:section:load', function (e) { init(e.target); cheadSeeMore(e.target); });
})();

/* Lookbook lightbox (phones only).
   Tapping an image opens it full-screen with its fabric list; swipe or the arrows
   move between looks. The (i) toggle keeps working - taps on it are ignored here. */
(function () {
  var MQ = '(max-width: 749px)';
  var box, imgEl, capEl, idx = 0, looks = [];

  function collect() {
    looks = [].slice.call(document.querySelectorAll('.esr-lb__look')).map(function (l) {
      var i = l.querySelector('.esr-lb__media img');
      var b = l.querySelector('.esr-lb__det-body');
      return i ? { src: i.currentSrc || i.src, alt: i.alt || '', cap: b ? b.innerHTML : '' } : null;
    }).filter(Boolean);
  }

  function build() {
    box = document.createElement('div');
    box.className = 'esr-lbx';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML =
      '<button class="esr-lbx__x" aria-label="Close">&times;</button>' +
      '<button class="esr-lbx__nav esr-lbx__prev" aria-label="Previous look">&#8249;</button>' +
      '<figure class="esr-lbx__fig"><img class="esr-lbx__img" alt=""><figcaption class="esr-lbx__cap"></figcaption></figure>' +
      '<button class="esr-lbx__nav esr-lbx__next" aria-label="Next look">&#8250;</button>';
    document.body.appendChild(box);
    imgEl = box.querySelector('.esr-lbx__img');
    capEl = box.querySelector('.esr-lbx__cap');
    box.addEventListener('click', function (e) {
      if (e.target.closest('.esr-lbx__prev')) return step(-1);
      if (e.target.closest('.esr-lbx__next')) return step(1);
      if (e.target.closest('.esr-lbx__x') || e.target === box || e.target.closest('.esr-lbx__fig') === null) close();
    });
    var sx = 0, sy = 0, st = 0, tracking = false;
    box.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now(); tracking = true;
    }, { passive: true });
    box.addEventListener('touchmove', function (e) {
      if (!tracking || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8 && e.cancelable) e.preventDefault();
    }, { passive: false });
    box.addEventListener('touchend', function (e) {
      if (!tracking) return; tracking = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Date.now() - st < 800 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-on')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    });
  }

  function draw() {
    var d = looks[idx]; if (!d) return;
    imgEl.src = d.src; imgEl.alt = d.alt;
    capEl.innerHTML = d.cap;
    box.querySelector('.esr-lbx__prev').hidden = looks.length < 2;
    box.querySelector('.esr-lbx__next').hidden = looks.length < 2;
  }
  function step(k) { if (!looks.length) return; idx = (idx + k + looks.length) % looks.length; draw(); }
  function open(n) {
    if (!box) build();
    collect(); idx = n; draw();
    box.classList.add('is-on');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    box.classList.remove('is-on');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (!window.matchMedia(MQ).matches) return;
    if (e.target.closest('summary')) return;          // the (i) keeps its own job
    var media = e.target.closest('.esr-lb__media');
    if (!media) return;
    var look = media.closest('.esr-lb__look');
    var all = [].slice.call(document.querySelectorAll('.esr-lb__look'));
    e.preventDefault();
    open(all.indexOf(look));
  });
})();

/* Header "Book appointment": the href is /pages/booking so pages without the
   booking tool go straight there instead of reloading the homepage with #aligner.
   Where the tool IS on the page (home, collections, city pages), scroll to it. */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-esr-book]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var target = document.getElementById('aligner');
    if (!target) return;                     // no tool here - follow the href
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#aligner');
  });
})();

/* Showroom prefill for the booking tool (booking.js itself is untouched).
   - ?showroom=London on a page with the tool selects that city in #salesLocation, the same way
     booking.js does it ($('select#salesLocation').val(city).trigger('change')).
   - Clicking a [data-esr-showroom] link on a page whose tool offers that city scrolls to the tool
     and selects it there instead of navigating away (e.g. Book buttons on /pages/our-locations). */
(function () {
  var norm = function (v) { return String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim(); };
  function optionFor(city) {
    var sel = document.querySelector('select#salesLocation');
    if (!sel || !city) return null;
    for (var i = 0; i < sel.options.length; i++) if (norm(sel.options[i].value) === norm(city)) return sel.options[i].value;
    return null;
  }
  function select(city) {
    var value = optionFor(city);
    if (!value || !window.jQuery) return false;
    window.jQuery('select#salesLocation').val(value).trigger('change');
    return true;
  }
  // booking.js initialises the form after load (and the page-speed app delays scripts until the first
  // interaction), so keep trying until our choice sticks. Stop once it has held for a moment, or as soon
  // as the visitor picks a different showroom themselves.
  function selectWhenReady(city) {
    var tries = 0, held = 0, ours = null;
    (function tick() {
      var sel = document.querySelector('select#salesLocation');
      var want = optionFor(city);
      if (sel && want) {
        var v = sel.value;
        if (v === want) { if (++held >= 3) return; }
        else if (ours && v && v !== 'epmty') return; // visitor changed it
        else { held = 0; if (select(city)) ours = want; }
      }
      if (++tries < 30) setTimeout(tick, 500);
    })();
  }
  var wanted = new URLSearchParams(location.search).get('showroom');
  if (wanted) selectWhenReady(wanted);

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-esr-showroom]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var target = document.getElementById('aligner');
    var city = a.getAttribute('data-esr-showroom');
    if (!target || !optionFor(city)) return; // tool not here or doesn't offer this city: follow the link
    e.preventDefault();
    select(city);
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', location.pathname + '?showroom=' + encodeURIComponent(city) + '#aligner');
  });
})();

/* Lookbook spec: the markup ships <details open> so the list is visible even if
   CSS fails or is cached stale (desktop behaviour). On phones collapse it behind
   the (i) instead. */
(function () {
  var MQ = window.matchMedia('(max-width: 749px)');
  function sync() {
    var open = !MQ.matches;
    document.querySelectorAll('.esr-lb__det').forEach(function (d) {
      if (!d.dataset.esrTouched) d.open = open;
    });
  }
  document.addEventListener('toggle', function (e) {
    if (e.target.classList && e.target.classList.contains('esr-lb__det')) e.target.dataset.esrTouched = '1';
  }, true);
  if (document.readyState !== 'loading') sync();
  else document.addEventListener('DOMContentLoaded', sync);
  if (MQ.addEventListener) MQ.addEventListener('change', function () {
    document.querySelectorAll('.esr-lb__det').forEach(function (d) { delete d.dataset.esrTouched; });
    sync();
  });
})();

/* Booking phone field: keep the typed number clear of the divider that follows
   the country selector. intl-tel-input writes padding-left inline (flag width
   + 6px) and recomputes it on every country change, so a static CSS value is
   overwritten; this re-applies "flag width + one gutter" after it. */
(function () {
  var GUTTER = 16;
  function sync() {
    var input = document.querySelector('.booking_section_overlay input#phone');
    if (!input) return;
    var flag = input.parentElement && input.parentElement.querySelector('.iti__selected-flag');
    if (!flag || !flag.offsetWidth) return;
    var want = Math.round(flag.offsetWidth + GUTTER) + 'px';
    if (input.style.paddingLeft !== want) input.style.setProperty('padding-left', want, 'important');
  }
  function start() {
    var box = document.querySelector('.booking_section_overlay .phone_block_input');
    if (!box) return;
    sync();
    // the dial code is rewritten in place when another country is picked
    new MutationObserver(sync).observe(box, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] });
    window.addEventListener('resize', sync);
  }
  var tries = 0;
  (function wait() {
    if (document.querySelector('.booking_section_overlay .iti__selected-flag')) return start();
    if (tries++ < 200) setTimeout(wait, 150);
  })();
})();

/* Booking advisor dropdown: booking.js empties #salesPerson and then appends one
   option per advisor, each from its own async get_days request. When get_days
   runs twice (entering step 3, then again when the calendar redraws), the second
   run's empty() lands before the first run's appends resolve - so both runs'
   options survive and every advisor is listed twice. ("No preference" is
   appended synchronously, which is why it shows up only once.)
   Drop the repeats as they arrive. Only later duplicates are removed, so the
   value booking.js reads with $('#salesPerson').val() is untouched, and select2
   rebuilds its list from the <select> each time the dropdown opens. */
(function () {
  function dedupe(sel) {
    var seen = {};
    Array.prototype.slice.call(sel.options).forEach(function (o) {
      if (seen[o.value]) o.parentNode.removeChild(o); else seen[o.value] = 1;
    });
  }
  var tries = 0;
  (function wait() {
    var sel = document.getElementById('salesPerson');
    if (sel) {
      dedupe(sel);
      new MutationObserver(function () { dedupe(sel); }).observe(sel, { childList: true });
      return;
    }
    if (tries++ < 200) setTimeout(wait, 150);
  })();
})();

/* Mobile menu drawer: end exactly at the sticky "Book your appointment" bar.
   Dawn sizes the drawer once as 100vh - --header-bottom-position; in iOS Safari (scrolled page,
   collapsing toolbars) that left a strip of page visible between the drawer and the bar.
   Measure what is actually on screen whenever the drawer opens or the viewport changes. */
(function () {
  var mq = window.matchMedia('(max-width: 989px)');
  function fit() {
    var drawer = document.getElementById('menu-drawer');
    var details = drawer && drawer.closest('details');
    if (!drawer || !details || !details.hasAttribute('open') || !mq.matches) return;
    var vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var bar = document.querySelector('.stickyBookingButton');
    var barTop = vh;
    if (bar && getComputedStyle(bar).display !== 'none') {
      var r = bar.getBoundingClientRect();
      if (r.height && r.top < vh) barTop = r.top;
    }
    var h = Math.max(240, Math.round(barTop - drawer.getBoundingClientRect().top));
    drawer.style.setProperty('height', h + 'px', 'important');
  }
  function later() { fit(); requestAnimationFrame(fit); setTimeout(fit, 350); }
  document.addEventListener('click', function (e) { if (e.target.closest('header-drawer summary')) setTimeout(later, 0); });
  window.addEventListener('resize', later);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', later);
  new MutationObserver(later).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
})();

/* Collection product cards: make the swipe to the fabric image catch first time.
   Slick's swipeMove gives up on the whole gesture as soon as the finger has
   moved more than 4px vertically, unless it has already latched `swiping` -
   which only happens once horizontal travel passes 4px:

     if (!verticalSwiping && !this.swiping && verticalDistance > 4) {
       this.scrolling = true; return false;      // swipeEnd then bails out
     }

   So whether a swipe registers comes down to how straight its first few pixels
   are, and a thumb flick arcs. Hence "I have to swipe three or four times".
   Latch `swiping` ourselves as soon as the gesture is clearly horizontal
   (moved > 4px across, and more across than down), which is the comparison
   slick should be making. A genuinely vertical drag still sets `scrolling` and
   still scrolls the page, and nothing here calls preventDefault. */
(function () {
  var el = null, startX = 0, startY = 0;
  document.addEventListener('touchstart', function (e) {
    el = e.target && e.target.closest ? e.target.closest('.mobile_media_slider') : null;
    if (!el || !e.touches || e.touches.length !== 1) { el = null; return; }
    startX = e.touches[0].pageX;
    startY = e.touches[0].pageY;
  }, true);
  document.addEventListener('touchmove', function (e) {
    if (!el || !e.touches || e.touches.length !== 1) return;
    var inst = el.slick;   // slick stores its instance on the element, not in jQuery data
    if (!inst || inst.swiping || inst.scrolling) return;
    var dx = Math.abs(e.touches[0].pageX - startX);
    var dy = Math.abs(e.touches[0].pageY - startY);
    if (dx > 4 && dx > dy) inst.swiping = true;
  }, true);
  function clear() { el = null; }
  document.addEventListener('touchend', clear, true);
  document.addEventListener('touchcancel', clear, true);
})();

/* Footer "Cookie settings": reopens the Cookiebot consent dialog, replacing the
   floating widget (hidden in es-redesign.css). Bound here rather than written as
   a javascript: href so it survives a Content-Security-Policy. If Cookiebot is
   not on the page - blocked, or not yet loaded - the link hides itself rather
   than sitting there doing nothing when clicked. */
(function () {
  function api() { return window.Cookiebot || window.CookieConsent || null; }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-esr-cookie-settings]') : null;
    if (!a) return;
    e.preventDefault();
    var c = api();
    if (c && typeof c.renew === 'function') c.renew();
  });
  function check() {
    var links = document.querySelectorAll('[data-esr-cookie-settings]');
    if (!links.length) return;
    var ok = !!(api() && typeof api().renew === 'function');
    links.forEach(function (a) { a.hidden = !ok; });
    return ok;
  }
  var tries = 0;
  (function wait() { if (check()) return; if (tries++ < 40) setTimeout(wait, 250); })();
})();

/* Pricing page: keep the "(n Fabrics)" counts and the "from" prices in step with
   the fabric catalogue.

   The catalogue rebuilds its data hourly (build-catalog.js cron), so the numbers
   typed into the template drift - every one of them was out of date by the time
   the mill names became links. This fetches one small summary
   (/apps/fabric-catalog/summary.json, ~5KB, cached an hour) after the page has
   loaded and corrects what is already on screen.

   Deliberately non-blocking: the template values render first and stand on their
   own, so a slow or failed request costs nothing and there is no layout shift -
   only the digits change. Prices come back for every market currency at once,
   because a JSON response is not Liquid processed and so cannot resolve the
   market server side; the table says which currency it is showing.
   Cells showing a dash are left alone: no price there is a deliberate "we do not
   offer this", not a missing number. */
(function () {
  var tables = document.querySelectorAll('[data-esr-ptable]');
  if (!tables.length) return;

  function group(n, sep) {
    var s = String(n);
    if (!sep || s.length < 4) return s;
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function apply(table, data) {
    var cat = table.getAttribute('data-esr-cat');
    var cur = table.getAttribute('data-esr-cur') || 'GBP';
    var sym = table.getAttribute('data-esr-sym') || '';
    var from = table.getAttribute('data-esr-from') || '';
    var sep = table.getAttribute('data-esr-sep') || '';
    var garments = (table.getAttribute('data-esr-garments') || '').split(',').map(function (g) { return g.trim(); });

    table.querySelectorAll('tbody tr').forEach(function (tr) {
      var a = tr.querySelector('.esr-ptable__link');
      if (!a) return;
      var brand = (a.getAttribute('href').match(/[?&]brand=([^&]+)/) || [])[1];
      var rowCat = (a.getAttribute('href').match(/[?&]cat=([^&]+)/) || [])[1] || cat;
      var entry = brand && data.brands[brand] && data.brands[brand][rowCat];
      if (!entry) return;

      var count = tr.querySelector('.esr-ptable__count');
      if (count && entry.count) {
        // "(1,046 Fabrics)" -> keep the word, replace the number
        var word = count.textContent.replace(/^\(\s*[\d.,'  ]+\s*/, '').replace(/\)\s*$/, '');
        count.textContent = '(' + group(entry.count, sep) + ' ' + word + ')';
      }

      var prices = entry.prices && entry.prices[cur];
      if (!prices) return;
      var cells = tr.querySelectorAll('td');
      garments.forEach(function (g, i) {
        var td = cells[i];
        if (!td || !g) return;
        if (!/\d/.test(td.textContent)) return;   // a dash means not offered - leave it
        var v = prices[g];
        if (v == null) return;
        td.innerHTML = '<small>' + from + '</small> ' + sym + group(v, '');
      });
    });
  }

  function run() {
    var bySrc = {};
    tables.forEach(function (t) {
      var src = t.getAttribute('data-esr-src');
      if (src) (bySrc[src] = bySrc[src] || []).push(t);
    });
    Object.keys(bySrc).forEach(function (src) {
      fetch(src, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && d.brands) bySrc[src].forEach(function (t) { apply(t, d); }); })
        .catch(function () { /* keep the typed values */ });
    });
  }

  // after load, and off the critical path
  if (document.readyState === 'complete') setTimeout(run, 0);
  else window.addEventListener('load', function () { setTimeout(run, 0); });
})();

/* Ready-to-wear size guide (snippets/esr-size-guide.liquid): renders the garment-measurement
   tables from the snippet's JSON, converts between cm and inches (choice remembered) and
   highlights the size the visitor has selected. */
(function () {
  var KEY = 'esr_size_unit';
  var ABBR = { 'small': 'S', 'medium': 'M', 'large': 'L', 'x-large': 'XL', 'xx-large': 'XXL' };
  function fmt(v, from, to) {
    if (from !== to) v = to === 'in' ? Math.round(v / 2.54 * 4) / 4 : Math.round(v * 2.54 * 2) / 2;
    return String(Math.round(v * 100) / 100);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // Selected option values for a table: the trousers table only looks at the trouser-size option, the jacket
  // table at the jacket-size option; other tables (shirts, field jackets) at every option.
  function selectedValues(title) {
    var vals = [], want = title === 'trousers' ? /trouser|hose/i : title === 'jacket' ? /jacket|sakko|veston/i : null;
    document.querySelectorAll('variant-radios input[type="radio"]:checked, variant-selects select').forEach(function (el) {
      if (want && !want.test(el.name || '')) return;
      var v = String(el.value || '').trim(); if (!v) return;
      vals.push(v.toLowerCase()); if (ABBR[v.toLowerCase()]) vals.push(ABBR[v.toLowerCase()].toLowerCase());
    });
    return vals;
  }
  function matches(size, vals) {
    var s = String(size).toLowerCase(), short = s.split(' (')[0];
    return vals.indexOf(s) > -1 || vals.indexOf(short) > -1;
  }
  function init(root) {
    if (root.__esrSg) return; root.__esrSg = true;
    var dialog = root.querySelector('dialog');
    var tables = JSON.parse(dialog.querySelector('[data-esr-sg-data]').textContent);
    var L = JSON.parse(dialog.querySelector('[data-esr-sg-labels]').textContent);
    // Move the popup out of the product form so it layers above the page and product-form scripts stay out of it.
    document.body.appendChild(dialog);
    var unit = root.getAttribute('data-default-unit') || 'cm';
    try { unit = localStorage.getItem(KEY) || unit; } catch (e) {}
    function render() {
      dialog.querySelectorAll('[data-esr-unit]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-esr-unit') === unit ? 'true' : 'false'); });
      dialog.querySelector('[data-esr-sg-tables]').innerHTML = tables.map(function (t) {
        var sel = selectedValues(t.title), hit = t.sizes.map(function (s) { return matches(s, sel); });
        var cls = function (i) { return hit[i] ? ' class="is-sel"' : ''; };
        var head = '<tr><th scope="col">' + esc(L.size) + '</th>' + t.sizes.map(function (s, i) { return '<th scope="col"' + cls(i) + '>' + esc(s) + '</th>'; }).join('') + '</tr>';
        var body = t.rows.map(function (r) {
          return '<tr><th scope="row">' + esc(L[r[0]] || r[0]) + '</th>' + r[1].map(function (v, i) { return '<td' + cls(i) + '>' + fmt(v, t.unit, unit) + '</td>'; }).join('') + '</tr>';
        }).join('');
        return '<section class="esr-sg__table"><h3>' + esc(L[t.title] || t.title) + '</h3>' +
          '<div class="esr-sg__scroll"><table class="esr-sg__grid"><thead>' + head + '</thead><tbody>' + body + '</tbody></table></div></section>';
      }).join('');
    }
    dialog.querySelectorAll('[data-esr-unit]').forEach(function (b) {
      b.addEventListener('click', function () { unit = b.getAttribute('data-esr-unit'); try { localStorage.setItem(KEY, unit); } catch (e) {} render(); });
    });
    root.querySelector('[data-esr-sg-open]').addEventListener('click', function () {
      render();
      if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      document.documentElement.classList.add('esr-sg-lock');
    });
    function close() { if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); }
    dialog.querySelector('[data-esr-sg-close]').addEventListener('click', close);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('esr-sg-lock'); });
  }
  function boot() { document.querySelectorAll('[data-esr-sg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
